<template>
    <div>
      <SaleReportKomisiList />
    </div>
</template>

<script>
import SaleReportKomisiList from '@/components/sales/report/SaleReportKomisiList.vue'
export default {
  name: 'SaleReportKomisi',
  components: {
    SaleReportKomisiList
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
  }
}
</script>
